// src/pages/Institution/institutionSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchInstitution, updateInstitution } from "./institutionThunk";

const institutionSlice = createSlice({
  name: "institution",
  initialState: {
    data: null,
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // 🔹 Fetch
      .addCase(fetchInstitution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInstitution.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchInstitution.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      // 🔹 Update
      .addCase(updateInstitution.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      // Update institution (merge new values into state.data)
      .addCase(updateInstitution.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        // merge updated values into existing state
        if (state.data) {
          const updated = action.meta.arg.values;

          state.data = {
            ...state.data,
            ...updated,
            // ✅ update file URLs if new ones uploaded
            
            branchLogo:
            updated.branchLogo?.[0]?.status === "done"
              ? updated.branchLogo[0].url
              : state.data.branchLogo,
            branchSignature:
            updated.branchSignature?.[0]?.status === "done"
              ? updated.branchSignature[0].url
              : state.data.branchSignature,
            branchStamp:
            updated.branchStamp?.[0]?.status === "done"
              ? updated.branchStamp[0].url
              : state.data.branchStamp,              
            
          };
        }
      })
      .addCase(updateInstitution.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload;
      });
  },
});

export default institutionSlice.reducer;
